import { ConversationContext, FragmentTranslations, HostContext, mapObject, nameof } from "@buzzeasy/shared-frontend-utilities";
import { ReactElement, useContext } from "react";
import { CallTranslatorMode } from "../model/hubDtos";
import MainContainer from "../components/containers/MainContainer";
import Providers from "../components/providers/Providers";
import { FragmentGlobalStyle } from "../GlobalStyle";
import { translations } from "../translations";

import "@buzzeasy/shared-frontend-utilities/extensions";

export interface CallTranslatorFragmentProps {
  mode: CallTranslatorMode;
  onTranscriptRecommended?: (shouldShow: boolean) => void;
}

export default function CallTranslatorFragment({ mode, onTranscriptRecommended }: CallTranslatorFragmentProps): ReactElement {
  const hostContext = useContext(HostContext);
  const conversationContext = useContext(ConversationContext);

  if (!hostContext || !conversationContext)
    throw new Error("CallTranslatorFragment must be rendered within a HostContext and ConversationContext");

  return (
    <Providers conversationId={conversationContext.conversationId} mode={mode}>
      <FragmentGlobalStyle />
      <MainContainer
        showHeader={false}
        conversationId={conversationContext.conversationId}
        onTranscriptRecommended={onTranscriptRecommended}
      />
    </Providers>
  );
}

CallTranslatorFragment.displayName = nameof({ CallTranslatorFragment });
CallTranslatorFragment.translations = mapObject(translations, ([lang, val]) => [lang, val.translation]) as FragmentTranslations;
